import { h } from 'preact'

export const AchatMobile = ({ title, items, cacheKey, eventId }) => {
   let background = eventId === 'achatMobile' ? '' : 'grey'
   return (
      <div class={`${background === 'grey' ? 'mb-2 mb-lg-4 bg-gray2 pt-2 pt-xl-3 pb-0 pb-sm-3 pb-xl-4' : 'mb-sm-3 mb-lg-4'}`}>
         <div class="container-fluid">
            <div data-testid={eventId === 'achatMobile' ? 'bande-achat-mobile-prospect' : 'bande-achat-forfait-prospect'} class="row" data-cache-key={cacheKey}>
               <div class="col-12">
                  <h2 class="mb-1 mb-md-2 mb-xl-3">{title}</h2>
               </div>

               {items.map(({ title, image, alt, description, CTA, analytics }, index) => (
                  <div class={`col-12 col-sm-6 px-0 px-sm-1 ${eventId === 'achatMobile' && index >= 1 ? 'd-none d-sm-flex' : ''}`}>
                     <div
                        data-testid="achat-item"
                        class="d-flex flex-column h-100 lien-composite"
                        data-pdb-zid={analytics.pdbZid}
                        data-pdb-sc={analytics.pdbSc}
                        data-pdb-idc={analytics.pdbIdc}
                        data-pdb-vi={analytics.pdbVi}
                        data-oevent-category={analytics.oeventCategory}
                        data-oevent-action={analytics.oeventAction}
                        data-oevent-label={analytics.oeventLabel}
                        data-oevent-other={analytics.oeventOther}
                     >
                        <picture>
                           <source srcset={`${image}?format=419x&saveas=webp`} media="(max-width: 419px)" />
                           <source srcset={`${image}?format=435x218&saveas=webp`} media="(max-width: 959px)" />
                           <source srcset={`${image}?format=533x267&saveas=webp`} media="(max-width: 1199px)" />
                           <img src={`${image}?format=645x323&saveas=webp`} alt={alt} class="w-100" loading="lazy" />
                        </picture>

                        <div class={`px-1 px-sm-2 pt-1 mt--1 d-flex flex-column flex-grow-1 ${background === 'grey' ? 'bg-gray2 bg-sm-white' : 'bg-dark'}`}>
                           <h3 class="text-primary mb-0 w-md-75">{title}</h3>
                           <p class={`lead mb-1 mt--1 ${background === 'grey' ? '' : 'text-white'} w-md-75`}>{description}</p>
                           <a
                              href={CTA.URL}
                              target={CTA.target}
                              class={`btn btn-secondary ${background === 'grey' ? '' : 'btn-inverse'} mb-3 mb-xl-4 mt-auto align-self-center align-self-sm-start`}
                           >
                              {CTA.label}
                           </a>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </div>
   )
}
